import IpsSidebar from './IpsSidebar.vue';
import '../../../styles/custom.scss';

export default IpsSidebar;
